import { createAction } from '@reduxjs/toolkit'

export const fetchMobileNotifications = createAction(
  'mobileNotifications/fetchMobileNotifications'
)
export const createMobileNotification = createAction(
  'mobileNotifications/createMobileNotifications'
)
